import { render } from "./EntrepriseContainerVue.vue?vue&type=template&id=b65f0ea4"
import script from "./EntrepriseContainerVue.vue?vue&type=script&lang=js"
export * from "./EntrepriseContainerVue.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\LCE\\Documents\\code\\front-end LCE\\centre-sante-gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__